import { Injectable } from '@angular/core';
import {HttpService} from "./http.service";
import {UserViewModel} from "../models/user-view-model";
import {LineDetailHoldCreateViewModel} from "../models/line-detail-hold-create-view-model";
import {LineDetailHoldReleaseViewModel} from "../models/line-detail-hold-release-view-model";

@Injectable({
  providedIn: 'root'
})
export class SettlementService {

  constructor(private _httpService: HttpService) {
  }

  public async HoldTransaction(hold: LineDetailHoldCreateViewModel): Promise<{success: boolean, message: string}> {
    const httpResult = await this._httpService.apiPost<{success: boolean, message: string}>(`settlement/hold`,hold);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {success: false, message: "An unknown error occured"}
  }

  public async ReleaseTransaction(release: LineDetailHoldReleaseViewModel): Promise<{success: boolean, message: string}> {
    const httpResult = await this._httpService.apiPost<{success: boolean, message: string}>(`settlement/release`,release);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {success: false, message: "An unknown error occured"}
  }

  public async GetUser(userId: string): Promise<UserViewModel> {
    const httpResult = await this._httpService.apiGet<UserViewModel>(`settlement/user/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

}
